<template>
  <div class="section-seo">
    <div class="container">
        <div 
          class="section-seo__banner" 
          v-for="(banner, i) in banners"
          :key="i"
        >
          <h2>{{ banner.name }}</h2>

          <div v-html="banner.caption" />
        </div>

        <!-- div class="col-xs-12 col-sm-6">
          <h2>Entdecken Sie unsere Märkte</h2>
          <p>Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi.
Nam liber tempor cum soluta nobis eleifend option congue nihil imperdiet doming id quod mazim placerat facer possim assum. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>
          <h3>Über ruckzuck.store</h3>
          <p>Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet.</p>
        </div -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MSectionSEO',
  computed: {
    ...mapGetters({
      getBannersBySlider: 'bannerslider/getBannersBySlider'
    }),
    banners () {
      return this.getBannersBySlider(3)
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
